import * as Apis from './Internal';
import {AtriaApi, BackendApi} from './Internal';

import IApi from './IApi';
import {lowercaseFirstLetter} from "../Tools/Text";

export interface Headers {
    [key: string]: string;
}

let instance: IApi;

const setAuthorization = (authorization: string) => {
    for (const [key] of Object.entries(instance)) {
        if (instance[key].setHeader) {
            instance[key].setHeader('Authorization', authorization);
        }
    }

    return instance;
};

const createInstance = (instanceName: string, baseUrl: string, token: string, headers?: Headers): IApi => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const newInstance: IApi = instance ? instance : {
        setAuthorization,
    };

    const apiName = lowercaseFirstLetter(instanceName).replace('Api', '');
    // eslint-disable-next-line import/namespace
    newInstance[apiName] = new (Function.prototype.bind.apply(Apis[instanceName], [null, baseUrl, token, headers]))();

    return newInstance;
};

const Api = {
    getAtriaInstance: (baseUrl: string, token: string, headers?: Headers): AtriaApi => {
        if (!instance?.atria) {
            instance = createInstance('AtriaApi', baseUrl, token, headers);
        }

        return instance.atria;
    },
    getBackendInstance: (baseUrl: string, token: string, headers?: Headers): BackendApi => {
        if (!instance?.backend) {
            instance = createInstance('BackendApi', baseUrl, token, headers);
        }

        return instance.backend;
    },
};

export default Api;
